import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export interface ConfirmRestoreDialogResult {
  confirmRestore: boolean
  evaluateGearRules: boolean
}

@Component({
  selector: 'confirm-restore-dialog',
  template: `
    <div mat-dialog-content style="overflow:hidden">
      <div>Are you sure you want to restore this file version?</div>
      <div style="text-align:center;margin:10px">
        <mat-checkbox [(ngModel)]="evaluateGearRules">Rerun applicable gear rules</mat-checkbox>
      </div>
    </div>
    <div mat-dialog-actions align="center">
      <button test-id="dialog-no-button" mat-button (click)="cancel()">No</button>
      <button test-id="dialog-yes-button" mat-flat-button color="primary" (click)="confirm()">Yes</button>
    </div>
  `,
})
export class ConfirmRestoreDialog {
  evaluateGearRules = true

  constructor(private ref: MatDialogRef<ConfirmRestoreDialog, ConfirmRestoreDialogResult>) {}

  confirm(): void {
    this.ref.close({ confirmRestore: true, evaluateGearRules: this.evaluateGearRules });
  }

  cancel(): void {
    this.ref.close({ confirmRestore: false, evaluateGearRules: this.evaluateGearRules });
  }
}
